export default __webpack_public_path__ + "low-density.png";